module.exports = __webpack_public_path__ + "static/media/codeguard-logo.dc899db9.png";